import * as styleVars from '../variables.scss';

export const MOBILE_BREAKPOINT = parseInt(styleVars['mobile-breakpoint']) || 415;
